// extracted by mini-css-extract-plugin
export default {"ModalOverlay":"bomModal-module_ModalOverlay_1-kaX","Modal":"bomModal-module_Modal_32dt3","Iframe":"bomModal-module_Iframe_1Dflx"};